module.exports = __webpack_public_path__ + "static/media/icons_Bilan de la coiffe des rotateurs.768ae516.svg";